// extracted by mini-css-extract-plugin
export default {"item":"Item_item__kn6-7","input":"Item_input__F9yjS","label":"Item_label__n93MQ"};